import { Reveal } from "../lib/anim";

const CHAPTERS = [
  {
    n: "01",
    title: "Our Mission",
    body:
      "AMCares is dedicated to improving the health and well-being of underserved communities through the distribution of essential hygiene supplies, health education, and partnerships with healthcare providers, schools, and community organizations.",
  },
  {
    n: "02",
    title: "Our Vision",
    body:
      "To build healthier communities by ensuring every individual has access to basic hygiene, health education, and opportunities to thrive with dignity.",
  },
  {
    n: "03",
    title: "Why It Matters",
    body:
      "Clarkston is one of the most culturally diverse communities in Georgia, home to many refugee and immigrant families navigating language barriers, transportation limits, and economic hardship. Access to essential hygiene supplies helps individuals stay healthy, reduce the spread of illness, and preserve self-confidence.",
  },
];

export const Manifesto = () => (
  <section id="mission" data-testid="manifesto" className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-12">
    <Reveal>
      <p className="text-xs md:text-sm uppercase tracking-[0.2em] text-brand-blue font-bold mb-4">The Manifesto</p>
      <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-brand-ink max-w-3xl leading-[1.02]">
        Health begins with the smallest of essentials.
      </h2>
    </Reveal>

    <div className="mt-16 md:mt-24 space-y-16 md:space-y-24">
      {CHAPTERS.map((c, i) => (
        <Reveal key={c.n} delay={i * 0.05}>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 border-t hairline pt-10">
            <div className="lg:col-span-3">
              <span className="font-mono text-sm text-brand-green">({c.n})</span>
              <h3 className="font-display text-2xl md:text-3xl text-brand-ink mt-3">{c.title}</h3>
            </div>
            <div className="lg:col-span-9">
              <p className="text-lg md:text-2xl text-brand-ink/70 leading-relaxed font-light text-balance">{c.body}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
